// extracted by mini-css-extract-plugin
export default {"academyEditLink":"styles_academyEditLink__1m6Qm","academyEditButton":"styles_academyEditButton__rSrb1","fadeIn":"styles_fadeIn__xSQQ5"};